import { Button, Container, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../components/LocalizedLink";
import MissionVisionValues from "../components/MissionVisionValues";
import "../assets/Home.css";

export default function Home() {
  const { t } = useTranslation();

  return (
    <main>
      <Helmet>
        <title>{t("schoolTitleMin")}</title>
        <meta name="description" content={t("homeDescription")} />
      </Helmet>
      <section
        className="pel-hero"
        style={{ backgroundImage: 'url("/pel.png")' }}
      >
        <div className="pel-hero-overlay" />
        <Container maxWidth="lg" className="pel-hero-content">
          <Typography variant="h1">{t("pelHeroTitle")}</Typography>
          <Typography variant="h5">{t("pelHeroSubtitle")}</Typography>
          <Button component={LocalizedLink} to="/research" variant="contained">
            {t("pelHeroCta")}
          </Button>
        </Container>
      </section>
      <MissionVisionValues />
    </main>
  );
}
